var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPet = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_animals"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.998 10A.75.75 0 1 1 10 11.5a.75.75 0 0 1-.002-1.5M14 10a.75.75 0 1 1 .002 1.5A.75.75 0 0 1 14 10",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 14.867a1 1 0 0 0 .5-.866.667.667 0 0 0-.666-.667h-.668A.667.667 0 0 0 11 14a1 1 0 0 0 .5.866v1.354a.782.782 0 0 1-1.334.553.5.5 0 0 0-.708.706A1.78 1.78 0 0 0 12 17.458a1.78 1.78 0 0 0 2.541.022.5.5 0 1 0-.707-.707.781.781 0 0 1-1.334-.55z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.166 16.313a8.506 8.506 0 0 0 15.668 0l1.088.182a.5.5 0 1 0 .164-.987l-.913-.152c.215-.748.33-1.538.33-2.356v-.27l.583-.097a.5.5 0 1 0-.164-.986l-.419.07v-6.18A2.038 2.038 0 0 0 17.14 3.99l-2.174 1.862a9.73 9.73 0 0 0-5.932 0L6.86 3.99a2.038 2.038 0 0 0-3.363 1.547v6.18l-.419-.07a.5.5 0 1 0-.164.986l.583.097V13c0 .818.115 1.608.33 2.356l-.913.152a.5.5 0 1 0 .164.987zM6.21 4.75a1.038 1.038 0 0 0-1.713.788v6.346l2.583.43a.5.5 0 1 1-.164.987l-2.42-.403V13a7.5 7.5 0 0 0 .325 2.19l2.095-.349a.5.5 0 1 1 .164.987l-1.895.316a7.504 7.504 0 0 0 13.63 0l-1.895-.316a.5.5 0 1 1 .164-.987l2.095.35a7.5 7.5 0 0 0 .324-2.19v-.104l-2.419.403a.5.5 0 1 1-.164-.986l2.583-.43V5.536a1.038 1.038 0 0 0-1.713-.788L15.4 6.797a.5.5 0 0 1-.491.091 8.73 8.73 0 0 0-5.818 0 .5.5 0 0 1-.492-.091z",
  clipRule: "evenodd"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPet);
export default ForwardRef;